import axios from "axios";

export const apiGetAvailableTopics = async (client, room, query) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };

    let url = ``;

    if (query.all) {
      url = `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/engage/${client}?room=${room}&all=true`;
    } else {
      url = `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/engage/${client}?room=${room}`;
    }

    const result = await axios.get(url, config).then(function (response) {
      if (response.status === 200) {
        const { data } = response;
        return data;
      } else {
        return null;
      }
    });
    return result;
  } catch (error) {
    console.log("error api session apiGetAvailableTopics");
    console.log(error);
    return null;
  }
};

export const apiGetTopicSpeakers = async (topic) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/speakers/${topic}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api speakers apiGetTopicSpeakers");
    console.log(error);
    return null;
  }
};

export const apiRemoveTopicSpeaker = async (topic, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/speakers/${topic}/remove`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api speakers apiRemoveTopicSpeakers");
    console.log(error);
    return null;
  }
};

export const apiAddTopicSpeaker = async (topic, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/speakers/${topic}/add`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api speakers apiAddTopicSpeaker");
    console.log(error);
    return null;
  }
};

export const apiPublicRegisterTopic = async (topic, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/speakers/${topic}/register`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api speakers apiPublicRegisterTopic");
    console.log(error);
    return null;
  }
};

export const apiUpdateTopicSpeaker = async (topic, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/speakers/${topic}/update`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api speakers apiUpdateTopicSpeaker");
    console.log(error);
    return null;
  }
};

export const apiGetSpeakersForMeeting = async (meeting) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/speakers/${meeting}/list`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api speakers apiGetTopicSpeakers");
    console.log(error);
    return null;
  }
};

export const apiGetTarrantRegistrationTopics = async (group, meeting) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/tarrant/${group}?meeting=${meeting}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });

    return result;
  } catch (error) {
    console.log("error api speakers apiGetTopicSpeakers");
    console.log(error);
    return null;
  }
};
